import { render } from "./AdminWithdrawal.vue?vue&type=template&id=1cca6638"
import script from "./AdminWithdrawal.vue?vue&type=script&lang=js"
export * from "./AdminWithdrawal.vue?vue&type=script&lang=js"

import "./AdminWithdrawal.vue?vue&type=style&index=0&id=1cca6638&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__